import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "../badRequestHandler/BadRequestHandler";

export const getEuroCustomerApi = createApi({
  reducerPath: "getEuroCustomerApi",
  baseQuery: dynamicBaseQuery,
  refetchOnMountOrArgChange: true,

  endpoints: (builder) => ({

     authenticateCustomer: builder.mutation({
        query: (body) => ({
          url: "v1/gc/send-otp/",
          method: "POST",
          body
        }),
      }),

      authenticateCustomerViaOtp: builder.mutation({
        query: (body) => ({
          url: "v1/gc/verify/",
          method: "POST",
          body
        }),
      }),

      signupCustomer: builder.mutation({
        query: (body) => ({
          url: "v1/gc/signup/",
          method: "POST",
          body
        }),
      }),

    }),
})



export const {useAuthenticateCustomerMutation, useAuthenticateCustomerViaOtpMutation, useSignupCustomerMutation} = getEuroCustomerApi;